export default (dispatch) => ({
  toggleCollectionVisibility: (collectionId, visibility) => {
    dispatch({
      type: 'features/setFeaturesVisibility',
      payload: { collectionId, type: 'collection', visibility }
    });
  }
});